import React, {useState, useRef, useEffect} from 'react';
import './CustomSelect.css';

const CustomSelect = ({options, placeholder, value, className, onChange}) => {
  const [isOpen, setIsOpen] = useState(false); // Состояние открытия/закрытия меню
  const [selectedOption, setSelectedOption] = useState(
    options.find((option) => option.value === value) || null
  );
  const selectRef = useRef(null); // Референс для управления фокусом и закрытием меню

  // Обновление selectedOption при изменении value
  useEffect(() => {
    const newSelectedOption = options.find((option) => option.value === value);
    setSelectedOption(newSelectedOption || null);
  }, [value, options]); // Перезапуск при изменении value или options

  // Обработчик выбора опции
  const handleOptionClick = (option) => {
    onChange(option);
    setSelectedOption(option);
    setIsOpen(false); // Закрываем меню после выбора
  };

  // Закрытие меню при клике вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`custom-select custom-select_small ${
        isOpen ? 'custom-select_open' : ''
      }`}
      ref={selectRef}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Поле ввода */}
      <div
        className={`custom-select__input custom-select__input_small ${className}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <input
          type='text'
          readOnly
          placeholder={placeholder}
          value={selectedOption ? selectedOption.label : ''}
          className='custom-select__input-inner'
        />
        <span className='custom-select__suffix'>
          <i className='custom-select__caret'></i>
        </span>
      </div>

      {/* Всплывающее меню */}
      {isOpen && (
        <div className='custom-select-dropdown custom-select-dropdown_popper'>
          <div className='custom-select-dropdown__scrollbar'>
            <ul className='custom-select-dropdown__list'>
              {options.map((option) => (
                <li
                  key={option.value}
                  className={`custom-select-dropdown__item ${
                    selectedOption?.value === option.value
                      ? 'custom-select-dropdown__item_selected'
                      : ''
                  }`}
                  onClick={() => handleOptionClick(option)}
                >
                  <span>{option.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
